<script>
  /**
   * History-API router using svelte-spa-router route-map + wrap() shape.
   * Upstream package is hash-only; closed stack requires pathname history.
   */
  import { onMount, tick } from 'svelte'
  import { parse } from 'regexparam'
  import { params as paramsStore } from './historyNav.js'

  export let routes = {}

  let Component = null
  let params = {}
  let extraProps = {}

  function compile(routesObj) {
    return Object.keys(routesObj || {}).map((path) => {
      const isWildcard = path === '*'
      const { pattern, keys } = isWildcard
        ? { pattern: /^[\s\S]*$/, keys: [] }
        : parse(path)
      return { path, pattern, keys, value: routesObj[path], isWildcard }
    })
  }

  function unwrap(value) {
    // wrap() objects: { component: asyncFn, conditions, props, _sveltesparouter }
    if (value && typeof value === 'object' && value._sveltesparouter === true) {
      return {
        load: value.component,
        conditions: value.conditions || null,
        props: value.props || {},
        userData: value.userData,
      }
    }
    if (value && typeof value === 'object' && typeof value.component === 'function') {
      return {
        load: value.component,
        conditions: value.conditions || null,
        props: value.props || {},
        userData: value.userData,
      }
    }
    return { load: () => Promise.resolve(value), conditions: null, props: {}, userData: undefined }
  }

  let navGen = 0

  async function navigate() {
    const myGen = ++navGen
    const pathname = window.location.pathname || '/'
    const compiled = compile(routes)
    const ordered = [
      ...compiled.filter((r) => !r.isWildcard),
      ...compiled.filter((r) => r.isWildcard),
    ]

    for (const r of ordered) {
      const m = r.pattern.exec(pathname)
      if (!m) continue
      const p = {}
      r.keys.forEach((k, i) => {
        p[k] = m[i + 1] ?? null
      })

      const wrapped = unwrap(r.value)
      if (Array.isArray(wrapped.conditions) && wrapped.conditions.length) {
        let ok = true
        for (const cond of wrapped.conditions) {
          const detail = {
            route: r.path,
            location: pathname,
            querystring: (window.location.search || '').replace(/^\?/, ''),
            params: p,
            userData: wrapped.userData,
          }
          // eslint-disable-next-line no-await-in-loop
          const pass = await cond(detail)
          if (!pass) {
            ok = false
            break
          }
        }
        if (!ok) return
      }

      try {
        const mod = await wrapped.load()
        if (myGen !== navGen) return
        const Comp = mod && mod.default ? mod.default : mod
        Component = Comp
        params = p
        extraProps = wrapped.props || {}
        paramsStore.set(Object.keys(p).length ? p : undefined)
        await tick()
      } catch (err) {
        console.error('route load failed', err)
        if (myGen === navGen) {
          Component = null
        }
      }
      return
    }

    if (myGen === navGen) {
      Component = null
      params = {}
      extraProps = {}
      paramsStore.set(undefined)
    }
  }

  function onNav() {
    navigate()
  }

  onMount(() => {
    navigate()
    window.addEventListener('popstate', onNav)
    window.addEventListener('lunes:navigate', onNav)
    return () => {
      window.removeEventListener('popstate', onNav)
      window.removeEventListener('lunes:navigate', onNav)
    }
  })
</script>

{#if Component}
  <svelte:component this={Component} params={params} {...extraProps} />
{:else}
  <p class="pm-meta" style="padding:2rem;text-align:center">Страница не найдена</p>
{/if}
